<div class="modal-confirm">
  <div class="modal-confirm__header">
    <h4 class="modal-confirm__title">
      {{ title() | translate }}
    </h4>
    <div
      role="button"
      tabindex="0"
      class="modal-confirm__cross-wrapper"
      (click)="closeModal(false)"
    >
      <app-icon class="modal-confirm__cross-icon" [icon]="iconName.MODAL_CROSS" />
    </div>
  </div>
  <p class="modal-confirm__description">
    {{ desc() | translate }}
  </p>

  @if (unavailableItems.length > 0) {
    <p class="modal-confirm__warning-summary">
      {{ 'confirmModal.warningSummary' | translate: { count: totalItemsCount } }}
    </p>

    <div class="modal-confirm__warning-container">
      <ul class="modal-confirm__item-list">
        @for (item of unavailableItems; track item) {
          <li>
            <span class="modal-confirm__item-name">{{ item.productName }}</span>
            <span class="modal-confirm__item-upc">{{ item.productUpc }}</span>
          </li>
        }
      </ul>
      @if (totalItemsCount > unavailableItems.length) {
        <span class="modal-confirm__view-all">
          {{ 'confirmModal.viewAll' | translate }}
        </span>
      }
    </div>
  }
  <div class="modal-confirm__btnWrapper">
    <button class="modal-confirm__button modal-confirm__cancel-btn" (click)="closeModal(false)">
      {{ 'confirmModal.cancel' | translate }}
    </button>
    <button class="modal-confirm__button modal-confirm__confirm-btn" (click)="closeModal(true)">
      {{ 'confirmModal.confirm' | translate }}
    </button>
  </div>
</div>
